export default {
  'customer.menuTitle': 'Customers',
};
